import axios from 'axios';
import { API_ROUTES } from '@/config/api-routes';
import { coercePhonePauseFlag } from '@/shared/model/phone-pause';
function unwrapProfileBody(data) {
    if (!data || typeof data !== 'object')
        return null;
    const root = data;
    const inner = root.data;
    if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
        return inner;
    }
    return root;
}
/** Normalize CRM profile fields used by softphone + ACW toolbar. */
export function normalizeCrmUserProfile(data) {
    const body = unwrapProfileBody(data);
    if (!body)
        return null;
    const profile = { ...body };
    if ('isPhonePause' in body) {
        profile.isPhonePause = coercePhonePauseFlag(body.isPhonePause);
    }
    if (typeof body.phonePauseEnd === 'string' && body.phonePauseEnd.trim()) {
        profile.phonePauseEnd = body.phonePauseEnd.trim();
    }
    else if (body.phonePauseEnd == null) {
        profile.phonePauseEnd = undefined;
    }
    return profile;
}
/**
 * Loads the logged-in user's CRM profile for softphone + activation fields.
 * Returns `null` when the backend has no profile yet (HTTP 404).
 */
export async function fetchCrmUserProfile() {
    try {
        const response = await axios.get(API_ROUTES.usersProfile);
        return normalizeCrmUserProfile(response.data ?? null);
    }
    catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 404) {
            return null;
        }
        throw error;
    }
}
